module.exports = __webpack_public_path__ + "img/perforaciones2_4-3_2048.08a947d5.jpg";